import postAPI from './postAPI.js'

export default async function getFlowActions(payload) {
    const data = await postAPI('admin/taskflows/actions/list', payload);
    return data;
}
